module.exports = __webpack_public_path__ + "static/media/m2-MY_PHYSICAL_ENVIRONMENT.2ba07fe3.png";